// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const wheelbarrow = defineModel({
  id: "wheelbarrow",
  batchId: "future",
  name: "Wheelbarrow",
  tags: ["scenery","wheelbarrow","low-poly","age-of-mcp","future"],
  summary: "A one-wheel barrow for moving small loads by hand — used everywhere.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.35,
  parts: () => [
      { geometry: new THREE.TorusGeometry(0.1, 0.035, 6, 12), color: "#4a4540", position: [0, 0.12, 0.32], rotation: [0, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.04, 0.06, 8), color: "#6e4f2e", position: [0, 0.12, 0.32], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.BoxGeometry(0.34, 0.05, 0.34), color: "#8a6840", position: [0, 0.22, 0.02] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.34), color: "#6e4f2e", position: [-0.16, 0.29, 0.02] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.34), color: "#6e4f2e", position: [0.16, 0.29, 0.02] },
      { geometry: new THREE.BoxGeometry(0.34, 0.14, 0.05), color: "#6e4f2e", position: [0, 0.29, -0.14] },
      { geometry: new THREE.SphereGeometry(0.1, 6, 5), color: "#c7b27a", position: [0, 0.3, 0.02], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.BoxGeometry(0.14, 0.14, 0.14), color: "#a9763f", position: [0.04, 0.32, -0.06] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.5), color: "#8a6840", position: [-0.14, 0.24, -0.32] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.5), color: "#8a6840", position: [0.14, 0.24, -0.32] },
      { geometry: new THREE.BoxGeometry(0.04, 0.2, 0.04), color: "#563d22", position: [0, 0.1, -0.12] },
    ],
  animations: [],
});
